import 'owl.carousel';

$(document).ready(function() {
  $('.owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    dots: true,
  });
});
